/**
 * Retorna o nome do operador atual para exibição em relatórios/logs.
 *
 * Regras:
 * - Se há operador logado (sessionStorage.brave_operador_data) → retorna `operador.nome`
 * - Caso contrário é o usuário master/admin → retorna `"Admin - {apelido}"`
 *
 * Retorna sempre uma string não-vazia. Se nada estiver disponível,
 * retorna "Admin".
 */
export function getOperadorNome() {
  try {
    const operadorRaw = sessionStorage.getItem("brave_operador_data");
    if (operadorRaw && operadorRaw !== "null") {
      const op = JSON.parse(operadorRaw);
      if (op?.nome) return op.nome;
    }
  } catch { /* ignore */ }
  try {
    const cli = JSON.parse(sessionStorage.getItem("brave_cliente_data") || "{}");
    const apelido = cli?.apelido || cli?.razao_social || "";
    return apelido ? `Admin - ${apelido}` : "Admin";
  } catch {
    return "Admin";
  }
}
